import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataLayerService } from './data-layer.service';

@Injectable({
    providedIn: 'root'
})
export class SessionPushService {

    constructor(private http: HttpClient, private datalayer: DataLayerService) { }

    push(e) {
        this.getSession().subscribe(a => {
            e.session = a.session
            this.datalayer.push(e)
        })
    }

    getSession() {
        return this.http.get<ITrackingSession>("/_mvc/booking/tracking")
    }

}

interface ITrackingSession {
    session: string
}
